export const getPage = (): string => {
  if (window.location.pathname && window.location.hash) {
    return window.location.pathname.split('/')[1].concat('/').concat(window.location.hash.split('#')[1]);
  }
  if (window.location.pathname === '/') {
    return 'HomeScreen';
  } else if (window.location.pathname) {
    return window.location.pathname.split('/')[1];
  } else {
    return '/';
  }
};

export const getSubTab = (): string => {
  return window.location.hash ? window.location.hash.split('#')[1] : '';
};
